(function () {
    'use strict';

    angular.module('vhols')

        .controller('ErrorPageController', ['$scope', 'sessionStorage', function errorPageController($scope, sessionStorage) {
            $scope.backLink = sessionStorage.get('vh.gd.referrer') || null;
        }]);


})();
